/**
 * Sollae Cloud - i18n Configuration (i18n.js)
 * 솔래 클라우드 - 다국어 설정 (i18n.js)
 * 
 * English:
 * - What: Settings file for the multi-language plugin (VueI18n).
 * - Usage: Sets up the i18n tool and defines the language messages.
 * - Feature Support: Handles multiple languages, switching languages, and default language settings.
 * - Why: Needed to show the app in English or Korean for users.
 * - Linked Files: locales/index.js (translation source), App.vue, and main.js.
 * - Editing Guide:
 *   - To change the default language, update the 'locale' setting.
 *   - To set a backup language, update 'fallbackLocale'.
 *   - To add a new language, import it and add it to the 'messages' list.
 * 
 * 한국어:
 * - 역할: VueI18n 다국어 플러그인 설정 파일입니다.
 * - 용도: i18n 인스턴스를 초기화하고 언어별 메시지를 정의합니다.
 * - 지원 기능: 다국어 지원(i18n), 동적 언어 전환 및 대체(fallback) 처리를 지원합니다.
 * - 필요성: 영어 및 한국어 사용자에게 현지화된 사용자 경험을 제공하기 위해 필수적입니다.
 * - 연결된 파일: locales/index.js (번역 소스), App.vue, 그리고 main.js를 연결합니다.
 * - 수정 가이드:
 *   - 기본 언어를 변경하려면 'locale' 속성을 수정하세요.
 *   - 대체 언어를 설정하려면 'fallbackLocale'을 수정하세요.
 *   - 새로운 언어는 임포트하여 'messages' 객체에 추가해야 합니다.
 */

import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from './index'; // Import combined translation messages (통합 번역 메시지 임포트)

Vue.use(VueI18n);

// Create and export the i18n instance
export default new VueI18n({
  locale: 'en', // Default locale
  fallbackLocale: 'en', // Fallback if translation is missing
  messages, // Translation data
});
